import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import GuidanceBubble from "layouts/guidance/components/GuidanceBubble";

/**
 * SnapshotTypeGuidance
 * Wraps a snapshot card and applies a highlight effect + tooltip for Live Demo mode.
 */
function SnapshotTypeGuidance({ children, isHighlighted, message }) {
    if (!isHighlighted) {
        return children;
    }

    return (
        <MDBox
            sx={{
                position: "relative",
                zIndex: 1500, // [UPDATED] Safe margin above backdrop (1250) and modals (1300)
                transform: "scale(1.05)",
                transition: "transform 0.3s ease",
                borderRadius: "xl", // Match card border radius if needed
            }}
        >
            <GuidanceBubble visible={true} message="Select Generic Snapshot" />
            {children}
        </MDBox>
    );
}

SnapshotTypeGuidance.propTypes = {
    children: PropTypes.node.isRequired,
    isHighlighted: PropTypes.bool,
    message: PropTypes.string,
};

export default SnapshotTypeGuidance;
